import { Decimal } from 'decimal.js';
import { IPositionResponse } from '../../services/api/api.interfaces';
import { tokenDecimals } from '../config/contracts.config';

export const calculatePositionSize = (price: number, leverage: number, amount: number, isLong: boolean) => {
    const numLeverage = leverage || 1;

    const res = isLong
        ? new Decimal(amount).mul(numLeverage).div(price)// (amount * numLeverage) / price
        : new Decimal(amount).mul(new Decimal(numLeverage).minus(1)).div(price);

    return res.toNumber();
}

export const calculatePositionSizeWithPosition = (position: IPositionResponse) => {
    return calculatePositionSize(Number(position.initialPrice), Number(position.leverage) || 1, new Decimal(position.amount).div(new Decimal(10).pow(tokenDecimals.usdc)).toNumber(), !position.isShort);
}

export const getNetPnlWithPosition = (position: IPositionResponse) => {
    return position.status === 'CLOSED' ? (position.realizedPnL && new Decimal(position.realizedPnL).div(new Decimal(10).pow(tokenDecimals.usdc)).toNumber()) : position.netPnlAmount;
}